import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { SelectInput, isNumber } from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

import styles from '../../../../css/settings.module.css'

const RpmTarget = ({ devices }) => {
  const {
    application_settings: applicationSettings,
    application_settings_new: applicationSettingsNew,
  } = devices[0] || {}

  const deviceRPMSettings = []
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let firstSpeed = 100

  if (testSettingsNew && isNumber(applicationSettingsNew.settings.speed) && applicationSettingsNew.status === 'new') {
    firstSpeed = applicationSettingsNew.settings.speed
  } else if (testSettings && isNumber(applicationSettings.settings.speed)) {
    firstSpeed = applicationSettings.settings.speed
  }

  for (let i = 0; i < devices.length; i += 1) {
    const device = devices[i]
    deviceRPMSettings.push({
      address: device.address,
      status: 'new',
      settings: {
        speed: firstSpeed,
      },
    })
  }

  const [speed, setSpeed] = useState(firstSpeed)
  const [deviceRPMSettingsState, setDeviceRPMSettingsState] = useState(deviceRPMSettings)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: deviceRPMSettingsState,
    })
  }, [deviceRPMSettingsState])

  useEffect(() => {
    appDispatch()
  }, [deviceRPMSettingsState])

  const childChange = useCallback((event) => {
    const { target: { name, value } } = event
    const newDeviceRPMSettings = []
    let newValue = value

    switch (name) {
      case 'speed':
        newValue = Number(value)
        break
      default:
        return
    }

    const len = deviceRPMSettingsState.length

    for (let i = 0; i < len; i += 1) {
      newDeviceRPMSettings.push(deviceRPMSettingsState[i])
      newDeviceRPMSettings[i].settings.speed = newValue
    }

    setSpeed(newValue)
    setDeviceRPMSettingsState(newDeviceRPMSettings)
  }, [deviceRPMSettingsState, appDispatch])

  const options = []
  for (let i = 18; i <= 28; i += 1) {
    options.push({
      value: (i * 100),
      name: `${(i * 100)} RPM`,
    })
  }

  return (
    <div>
      <div className={`${styles.inputArea} ${styles.paddedInputArea}`} style={{ paddingBottom: '32px', paddingLeft: '16px' }}>
        <section>
          <h5>
            <FormattedMessage
              id='setting.speed.target.label'
              defaultMessage='RPM Target'
              description='RPM Target label'
            />
          </h5>
          <div className={`${styles.controlNumber}`} style={{ marginTop: '10px' }}>
            <SelectInput
              value={speed}
              childChange={childChange}
              field='speed'
              options={options}
              style={styles.controlSelectInput}
            />
          </div>
        </section>
      </div>
    </div>
  )
}

RpmTarget.propTypes = {
  devices: PropTypes.array.isRequired,
}

export default RpmTarget
